export default "__VITE_ASSET__777f6630__"